// extracted by mini-css-extract-plugin
export default {"calendar-grid":"CalendarGrid_calendar-grid__NSxOU","time-slot-row":"CalendarGrid_time-slot-row__7TUUy","event-item":"CalendarGrid_event-item__TgneL"};